import { AdminCafeStaffSearchLogs } from '@cookspace-shared-contracts/core';

import { baseApi } from '@/api/baseApi';
import { parseWithSchema } from '@/lib/safeParse';

/**
 * RTK Query endpoint РґР»СЏ admin-backend /admin/cafe-staff-search-logs.
 *
 * Audit-log РїРѕРёСЃРєР° СЃРѕС‚СЂСѓРґРЅРёРєРѕРІ/РїСЂРѕС„Рё РєР°С„Рµ вЂ” read-only РґР»СЏ super_admin.
 */
export const cafeStaffSearchLogsApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        listAdminCafeStaffSearchLogs: build.query<
            AdminCafeStaffSearchLogs.GetAdminCafeStaffSearchLogsResponse,
            AdminCafeStaffSearchLogs.GetAdminCafeStaffSearchLogsRequest | void
        >({
            query: (params) => {
                const search: Record<string, string> = {};
                if (params?.cafeId !== undefined && params.cafeId !== '') {
                    search.cafeId = params.cafeId;
                }
                if (
                    params?.performedByUserId !== undefined &&
                    params.performedByUserId !== ''
                ) {
                    search.performedByUserId = params.performedByUserId;
                }
                if (params?.from !== undefined && params.from !== '') {
                    search.from = params.from;
                }
                if (params?.to !== undefined && params.to !== '') {
                    search.to = params.to;
                }
                if (params?.limit !== undefined) {
                    search.limit = String(params.limit);
                }
                if (params?.offset !== undefined) {
                    search.offset = String(params.offset);
                }
                return {
                    url: '/cafe-staff-search-logs',
                    method: 'GET',
                    params: search
                };
            },
            transformResponse: (
                raw: unknown
            ): AdminCafeStaffSearchLogs.GetAdminCafeStaffSearchLogsResponse =>
                parseWithSchema(
                    AdminCafeStaffSearchLogs.GetAdminCafeStaffSearchLogsResponseSchema,
                    raw
                ),
            providesTags: (result) =>
                result
                    ? [
                        ...result.items.map((s) => ({
                            type: 'CafeStaffSearchLog' as const,
                            id: s.id
                        })),
                        { type: 'CafeStaffSearchLog' as const, id: 'LIST' }
                    ]
                    : [{ type: 'CafeStaffSearchLog' as const, id: 'LIST' }]
        })
    })
});

export const { useListAdminCafeStaffSearchLogsQuery } = cafeStaffSearchLogsApi;
